<template>
  <section v-if="!isLoading">
    <div class="relative pb-7">
      <h1
        class="absolute top-7 left-0 right-0 bottom-0 text-orange-600 text-lg font-semibold text-center"
      >
        Transaction History
      </h1>
    </div>

    <div
      class="w-10 h-10 flex items-center justify-center rounded-full bg-gray-200 hover:bg-gray-300 cursor-pointer shadow-md transition"
    >
      <BackSvg @click="$router.go(-1)" />
    </div>
    <div v-for="group in groupedByDate" :key="group.date" class="my-8">
      <h4 class="text-secondaryPalette font-semibold text-sm">
        {{ dateFormatMonthDateYear(group.date) }}
      </h4>
      <ul>
        <li
          v-for="item in group.transactions"
          :key="item.id"
          class="bg-white my-3 px-5 py-4 flex items-center gap-4 rounded-2xl shadow-sm hover:shadow-lg hover:-translate-y-[2px] transition-all duration-200 cursor-pointer border border-gray-100"
          @click="routeDetails(item.approvalno)"
        >
          <!-- Icon Container -->
          <div
            class="w-10 h-10 flex items-center justify-center rounded-full bg-red-50 text-red-500"
          >
            <CrossSvg class="w-5 h-5" />
          </div>

          <!-- Content -->
          <div class="flex flex-col flex-1">
            <!-- Approval Number -->
            <span class="text-xs text-gray-400 tracking-wider uppercase">
              {{ item.approvalno }}
            </span>

            <!-- Provider -->
            <span class="text-secondaryPalette font-semibold text-sm mt-1">
              {{ item.provider.ProviderAmap }}
            </span>
            <span class="text-secondaryPalette/80 font-medium text-xs mt-1">
              BRANCH: {{ item.provider.Branch }}
            </span>
          </div>

          <!-- Optional Right Arrow (Better UX) -->
          <svg
            class="w-4 h-4 text-gray-300 group-hover:text-gray-400 transition"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9 5l7 7-7 7"
            />
          </svg>
        </li>
      </ul>
    </div>
  </section>
  <div v-else>
    <div class="flex items-center justify-center h-48" v-if="isLoading">
      <svg
        class="w-10 h-10 animate-spin text-orange-600"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          class="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="4"
        ></circle>
        <path
          class="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
        ></path>
      </svg>
    </div>
  </div>
</template>

<script>
import { inject, ref, onMounted, computed } from "vue";
import reusableBase from "@/utils/composables/format";
import CrossSvg from "@/components/svgs/HospitalSvg.vue";
//import StampSvg from "@/components/svgs/StampSvg.vue";
import BackSvg from "@/components/svgs/BackSvg.vue";
import { useRouter } from "vue-router";
export default {
  components: {
    // HospitalSvg,
    CrossSvg,
    BackSvg,
  },
  setup() {
    const router = useRouter();
    const axios = inject("$axios");
    const itemTransaction = ref([]);
    const { dateFormatMonthDateYear } = reusableBase();
    const isLoading = ref(true);
    onMounted(async () => {
      try {
        isLoading.value = true;

        const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
        const { data } = await axios.get(
          `/meta/api/amap/resources/transaction/loa`
        );
        itemTransaction.value = data.result;
        console.log(itemTransaction.value);
        await delay(2000);
        isLoading.value = false;
      } catch (error) {
        console.log("render", error);
      }
    });

    // Group by date and order by max transaction id descending
    const groupedByDate = computed(() => {
      const grouped = itemTransaction.value.reduce((acc, item) => {
        const key = item.date_generate.split("T")[0]; // group by date
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
      }, {});

      // Convert to array, sort groups by max transaction id, and sort transactions inside each group
      return Object.entries(grouped)
        .map(([date, transactions]) => {
          // Sort transactions by id descending
          transactions.sort((a, b) => b.id - a.id);
          const maxId = transactions[0]?.id || 0;
          return { date, transactions, maxId };
        })
        .sort((a, b) => b.maxId - a.maxId) // sort groups by maxId descending
        .map(({ date, transactions }) => ({ date, transactions })); // remove maxId for template
    });
    const routeDetails = (id) => {
      router.push(`/auth/request/loa/transaction/detail/${id}`);
    };

    return {
      itemTransaction,
      groupedByDate,
      dateFormatMonthDateYear,
      routeDetails,
      isLoading,
    };
  },
};
</script>
